import { render } from "./Privacidad.vue?vue&type=template&id=ef05343a&scoped=true"
import script from "./Privacidad.vue?vue&type=script&lang=js"
export * from "./Privacidad.vue?vue&type=script&lang=js"

import "./Privacidad.vue?vue&type=style&index=0&id=ef05343a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef05343a"]])

export default __exports__